import { NgModule } from '@angular/core';
import {CommonModule, NgIf} from '@angular/common';
import { CustomerFormComponent } from './customer-form.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatFormFieldModule} from "@angular/material/form-field";
import {TranslationFeatureModule} from "../../i18n/TranslationFeatureModule";
import {MatRadioButton, MatRadioGroup, MatRadioModule} from "@angular/material/radio";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatCheckboxModule} from "@angular/material/checkbox";

@NgModule({
  declarations: [CustomerFormComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatIconModule,
        MatTooltipModule,
        TranslationFeatureModule,
        MatRadioButton,
        MatRadioGroup,
        MatExpansionModule,
        FormsModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule,
        NgIf,
        ReactiveFormsModule,
    ],
  exports: [CustomerFormComponent],
})
export class CustomerFormModule { }
